import NextVector from "../../../assets/NextVector";
import Button, { ButtonProps } from "./Button";

export default function FastForward({ disabled, onClick }: ButtonProps) {
	const stroke = disabled ? "#9395a2" : "#ff5f43";

	return (
		<Button variant="text" onClick={() => onClick!()}>
			<NextVector stroke={stroke} fill="none" />
			<NextVector stroke={stroke} fill="none" />
		</Button>
	);
}
